import React, {Component} from "react"

import ErrorText from "@irati/ui/src/ErrorText"
import {H2} from "@irati/ui/src/Typography/Heading"
import Loader from "@irati/ui/src/Loading/Loader"
import id from "@irati/utils/id"
import {getQuery} from "@irati/utils/history"
import {FormattedMessage, injectIntl} from "@irati/utils/lang"
import session from "@irati/auth/services/session"

import LoginBackground from "../LoginBackground"

class LoadingResetPassword extends Component {
  state = {
    isLinkInvalid: false
  }

  componentDidMount = () => {
    const {uuid, verificationCode, subdomain} = getQuery()
    if (!uuid || !verificationCode || !subdomain) {
      this.setState({isLinkInvalid: true})
    } else {
      const postData = {
        uuid,
        verificationCode
      }
      const options = {pathname: "/welcome/login/reset-password"}
      return session.postCrossDomain(subdomain, postData, options)
    }
  }

  render() {
    const {isLinkInvalid} = this.state
    /** all containers should force namespace as they are the initial root */
    const idNamespace = id("loading-reset-password", this.props)

    if (isLinkInvalid) {
      return (
        <ErrorText id={id("copy_error", idNamespace)}>
          <FormattedMessage id="platform.loadingResetPassword.error.text" />
        </ErrorText>
      )
    }
    return (
      <LoginBackground id={idNamespace}>
        <H2 id={id("title", idNamespace)} className="text-center">
          <FormattedMessage id="platform.loadingResetPassword.header.text" />
        </H2>
        <Loader id={idNamespace} />
      </LoginBackground>
    )
  }
}

export default injectIntl(LoadingResetPassword)
